import { IFilterOptions } from '@quadminds/shared/commons';
import { ICoordinate } from './coordinate.interface';
import { IDeleteOutputDto } from './delete-output-dto.interface';
import { RouteStatusEnum } from '../enums/route-status.enum';

export interface IRouteFilterOptions extends IFilterOptions {
    sortByVicinityTo?: string;
    destinationVicinityTo?: string;
    maxLookupDistance?: number;
    distanceLookupField?: string;
}

export interface IRouteOutputDto extends IDeleteOutputDto {
    id: string;
    organizationId?: string;
    externalId?: string;
    name: string;
    status: RouteStatusEnum;
    statusMessage?: string;
    fileUrl?: string;
    polyline?: string;
    origin?: ICoordinate;
    destination?: ICoordinate;
    originAddress?: string;
    destinationAddress?: string;
    distanceKm?: number;
    createdAt?: string;
    updatedAt?: string;
}
